/**
 * Created by ALEC ;) on 666/666/666
 */


import ApplicationServices from './base-service.js';
import TranslationConstants from '../constants/translation.js';
import Action from '../actions/default.js';


class TranslationServices {

    constructor() {

    }
    getAllCurriculums() {
        return ApplicationServices.call(TranslationConstants.GET_ALL_CURRICULUMS_TRANS, {}).then(function (response) {
            Action.update(TranslationConstants.UPDATE_ALL_CURRICULUMS_TRANS, response.currs);
        });
    }

    getAllLanguages() {
        return ApplicationServices.call(TranslationConstants.GET_ALL_LANGUAGES_RAW, {}).then(function (response) {
            Action.update(TranslationConstants.GOT_ALL_LANGUAGES_RAW, response.languages);
        });
    }

    getData(type, language, curr, uid, search, isLive) {
        return ApplicationServices.call(TranslationConstants.GET_DATA, { type: type, language: language, curr: curr, uid: uid, search: search, isLive: isLive }).then(function (response) {
            Action.update(TranslationConstants.TRANS_DATA_GOT, response.data);
        });
    }

    submitUpdate(table, uid, old_value, new_value, new_pic, new_audio) {
        return ApplicationServices.call(TranslationConstants.ADD_UPDATE, { table: table, uid: uid, old_value: old_value, new_value: new_value, new_pic: new_pic, new_audio: new_audio }).then(function (response) {
            Action.update(TranslationConstants.UPDATES_GOT_DATA, response.data);
        });
    }

    performUpdate() {

        return ApplicationServices.call(TranslationConstants.PERFORM_UPDATES, {}).then(function (response) {
            Action.update(TranslationConstants.TRANS_UPDATE_GOT, response.data);
        });
    }

    getUnappliedChanges() {
        return ApplicationServices.call(TranslationConstants.GET_UPDATES_TRANS, {}).then(function (response) {
            Action.update(TranslationConstants.TRANS_UPDATE_GOT, response.data);
        });
    }

    deleteTranslation(e) {
        return ApplicationServices.call(TranslationConstants.DELETE_TRANS_UPDATE, { uid: e.uid }).then(function (response) {

        });
    }

    addNewTranslations(newTranslations) {
        return ApplicationServices.call(TranslationConstants.SUBMIT_NEW_TRANSLATIONS, { trans: newTranslations }).then(function (response) {
            Action.update(TranslationConstants.NEW_TRANS_ADDED_CONTENT, response.done);
        });
    }

    updateNote(note) {

        return ApplicationServices.call(TranslationConstants.UPDATE_NOTE, { uid: note.uid, note: note.note }).then(function (response) {

        });
    }


    getAddNewTranslationContent(uid) {

        return ApplicationServices.call(TranslationConstants.GET_ADD_NEW_TRANSLATION_CONTENT, { uid:uid}).then(function (response) {
            Action.update(TranslationConstants.TRANS_UPDATE_GOT_CONTENT, response.data);
        });
    }

    updateUpdate(uid, newUpdate) {

        return ApplicationServices.call(TranslationConstants.UPDATE_UPDATE, { uid: uid, newUpdate: newUpdate }).then(function (response) {

        });
    }

    addNewTranslationForExisitingUid(uid, translation, language) {

        return ApplicationServices.call(TranslationConstants.ADD_TRANS_FOR_EXIST, { uid: uid, translation: translation, language: language }).then(function (response) {

        });

    }


    setLive(uid, isLive, typeOption) {

        return ApplicationServices.call(TranslationConstants.UPDATE_IS_LIVE, { uid: uid, isLive: isLive, type: typeOption }).then(function (response) {

        });
    }

}


export default new TranslationServices();


// WEBPACK FOOTER //
// ./src/services/translation-service.js